module.exports = __webpack_public_path__ + "img/dc0b1ea.jpg";